import { Button, Card, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import BinLocationService from '../../../services/Wash-service/BinLocationService';
import ResponseMessage from '../../Comman/Notification/ResponseMessge';

const KCA_KanbanScanConfrim = ({ userdata }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [binId, setBinId] = useState();

    useEffect(() => {
        const fetchKanbanData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const bin_id = queryParams.get('kanbanId');

            setBinId(bin_id);

            if (!bin_id) {
                ResponseMessage.error({ message : "No Kanban ID provided."});
                return;
            }
        };

        fetchKanbanData();

    }, [location, userdata.su_id, navigate]);

    const handleConfirm = async () => {
        if (!binId) {
            ResponseMessage.error({ message : "No Kanban ID available."});
            return;
        }

        try {
            const response = await BinLocationService.sendKanbanFinish(binId, userdata.su_id);
            console.log(response.message);

            if (response && response.data) {
            } else {
                ResponseMessage.warning({ message : response.message || "No Kanban data available."});
                
            }
        } catch (error) {
            console.error("Error in handleConfirm:", error);
            ResponseMessage.error({ message : error.message || "An error occurred."});
           
        }
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                    height: '100vh',
                }}
            >
                <Card
                    title={
                        <div style={{ fontSize: '24px', fontWeight: 'bold', gap: '30px' }}>
                            <QuestionCircleTwoTone />  Confirm Finishing!
                        </div>
                    }
                    style={{
                        width: 600,
                        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.3)',
                        borderRadius: '10px',
                        padding: '20px',
                    }}
                >
                    <p
                        style={{
                            fontSize: '18px',
                        }}
                    >
                        Are you sure you want to confirm Finish kanban <strong>{binId}</strong> ?

                    </p>
                    <Button
                        type="primary"
                        onClick={handleConfirm}
                        style={{
                            width: '100%',
                            marginTop: '20px',
                            padding: '10px',
                            fontSize: '16px',
                        }}
                    >
                        Confirm Finishing
                    </Button>
                </Card>
            </div>

        </>
    )
}

export default KCA_KanbanScanConfrim;